import { render, staticRenderFns } from "./SelectPartGroupsPage.vue?vue&type=template&id=ec713436&"
import script from "./SelectPartGroupsPage.vue?vue&type=script&lang=js&"
export * from "./SelectPartGroupsPage.vue?vue&type=script&lang=js&"
import style0 from "./SelectPartGroupsPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VContainer,VIcon,VTreeview})
